<app-nav (showDialog)="show($event)" class="d-print-none"></app-nav>
<div class="container-xl mt-3">
  <div class="row">
    <main role="main" class="col">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>